/* eslint-disable import/no-cycle */
// Utils
import { hasUncommitted } from '../hasUncommited';
import { commitOrReturn } from './commitOrReturn';
// Types
import { COMMITTED_VALUES } from '../constants';
/**
 * @description
 * For the given object return a copy with a new method called `_getCommittedValues`. This method
 * resolves to the reference of the initial given object.
 *
 * For clarity please pay attention to the example below.
 *
 * @example
 * inputObject = {
 *   x: 1,
 *   y: { x: 2 },
 * }
 *
 * outputObject = {
 *   x: 1,
 *   _getCommittedValues: () => outputObject,
 *   y: {
 *     x: 2,
 *     _getCommittedValues: () => outputObject.y,
 *   },
 * }
 *
 * @template T extends object
 * @param {T} values
 * @return {T}
 */
export var commitObject = function (values) {
    var result = values;
    if (hasUncommitted(result)) {
        var newResult_1 = {};
        Object.keys(result).forEach(function (key) {
            newResult_1[key] = commitOrReturn(result[key]);
        });
        Object.defineProperty(newResult_1, COMMITTED_VALUES, {
            configurable: true,
            enumerable: true,
            writable: false,
            value: function () { return newResult_1; },
        });
        result = newResult_1;
    }
    return result;
};
//# sourceMappingURL=commitObject.js.map